
import { Vue } from "vue-property-decorator"

export default class Container extends Vue {}
